<section class="user-details center-layout">
  <div class="form-central__content">
    @if (!isTokenResponse) {
      <div class="form-central__form">
        <div class="logo-wrapper">
          <img
            src="../../../../../assets/images/rexpay.svg"
            alt="Rexpay logo"
            />
        </div>
        <p class="mt-3">Select how you want to be debited</p>
        <div class="payment-tabs flexed mt-3">
          <div
            class="flexed payment-tab mr-3 align-items-center"
            [ngClass]="{ tab_active: tabIndex === 0 }"
            (click)="changeTab(0)"
            >
            <div class="payment-icon mr-3">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                >
                <g clip-path="url(#clip0_2711_16088)">
                  <path
                    d="M19 3H5C3.67441 3.00159 2.40356 3.52888 1.46622 4.46622C0.528882 5.40356 0.00158786 6.67441 0 8H24C23.9984 6.67441 23.4711 5.40356 22.5338 4.46622C21.5964 3.52888 20.3256 3.00159 19 3Z"
                    fill="#9C9898"
                    />
                  <path
                    d="M0 16C0.00158786 17.3256 0.528882 18.5964 1.46622 19.5338C2.40356 20.4711 3.67441 20.9984 5 21H19C20.3256 20.9984 21.5964 20.4711 22.5338 19.5338C23.4711 18.5964 23.9984 17.3256 24 16V10H0V16ZM7 15.5C7 15.7967 6.91203 16.0867 6.7472 16.3333C6.58238 16.58 6.34811 16.7723 6.07403 16.8858C5.79994 16.9993 5.49834 17.029 5.20736 16.9712C4.91639 16.9133 4.64912 16.7704 4.43934 16.5607C4.22956 16.3509 4.0867 16.0836 4.02882 15.7926C3.97094 15.5017 4.00065 15.2001 4.11418 14.926C4.22771 14.6519 4.41997 14.4176 4.66664 14.2528C4.91332 14.088 5.20333 14 5.5 14C5.89782 14 6.27936 14.158 6.56066 14.4393C6.84196 14.7206 7 15.1022 7 15.5Z"
                    fill="#9C9898"
                    />
                </g>
                <defs>
                  <clipPath id="clip0_2711_16088">
                    <rect width="24" height="24" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>
            <p class="tab-title">Card</p>
          </div>
          <div
            class="flexed payment-tab"
            [ngClass]="{ tab_active: tabIndex === 1 }"
            (click)="changeTab(1)"
            >
            <div class="payment-icon mr-3">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                >
                <g clip-path="url(#clip0_2711_16099)">
                  <path
                    d="M0.290658 8.55203C0.0751807 8.15235 -0.0246469 7.70053 0.00237884 7.24728C0.0294046 6.79402 0.182214 6.35726 0.443658 5.98603C0.870917 5.35914 1.4431 4.84459 2.11166 4.48603L9.61266 0.582025C10.3499 0.198656 11.1687 -0.00149536 11.9997 -0.00149536C12.8306 -0.00149536 13.6494 0.198656 14.3867 0.582025L21.8867 4.48903C22.5552 4.84759 23.1274 5.36214 23.5547 5.98903C23.8161 6.36026 23.9689 6.79702 23.9959 7.25028C24.023 7.70353 23.9231 8.15535 23.7077 8.55503C23.4757 8.99385 23.1277 9.36063 22.7017 9.61541C22.2758 9.8702 21.788 10.0032 21.2917 10H2.70766C2.21082 10.0031 1.72266 9.86973 1.29645 9.61439C0.87023 9.35905 0.522317 8.99157 0.290658 8.55203ZM22.9997 22C22.9997 21.4696 22.7889 20.9609 22.4139 20.5858C22.0388 20.2107 21.5301 20 20.9997 20V12H18.9997V20H15.9997V12H13.9997V20H9.99966V12H7.99966V20H4.99966V12H2.99966V20C2.46923 20 1.96052 20.2107 1.58545 20.5858C1.21037 20.9609 0.999659 21.4696 0.999659 22C0.734442 22 0.480088 22.1054 0.292552 22.2929C0.105015 22.4805 -0.000341587 22.7348 -0.000341587 23C-0.000341587 23.2652 0.105015 23.5196 0.292552 23.7071C0.480088 23.8947 0.734442 24 0.999659 24H22.9997C23.2649 24 23.5192 23.8947 23.7068 23.7071C23.8943 23.5196 23.9997 23.2652 23.9997 23C23.9997 22.7348 23.8943 22.4805 23.7068 22.2929C23.5192 22.1054 23.2649 22 22.9997 22Z"
                    fill="#9C9898"
                    />
                </g>
                <defs>
                  <clipPath id="clip0_2711_16099">
                    <rect width="24" height="24" fill="white" />
                  </clipPath>
                </defs>
              </svg>
            </div>
            <p class="tab-title">Bank</p>
          </div>
        </div>
        <div class="mt-3">
          @if (tabIndex === 0) {
            <app-recurring-card-payment
              (emitCardPayment)="makeCardPayment($event)"
            ></app-recurring-card-payment>
          }
          @if (tabIndex === 1) {
            <app-recurring-bank-payment
              (emitBankPayment)="makeBankPayment($event)"
            ></app-recurring-bank-payment>
          }
        </div>
        <div
          class="footer"
          style="margin-top: 3rem; text-align: center; font-size: 12px"
          >
          Powered By:
          <img width="50" src="../../../assets/rexpay/ga.png" />
        </div>
      </div>
    }

    @if (isTokenResponse) {
      <app-reoccuring-otp
        [providerResponse]="providerResponse"
        (emitOTP)="submitOtp($event)"
        (emitResendOtp)="resendOtp()"
      ></app-reoccuring-otp>
    }
  </div>
</section>

<app-error-dialog
  [visible]="showErrorModal"
  [message]="subHeader"
  (closed)="showErrorModal = false"
  />

@if (showBankDetails) {
  <app-modal
    [modalType]="'primary'"
    header="REXPAY-NIBBS e-Mandate"
    subHeader="Welcome to REXPAY-NIBBS e-mandate authentication service. Please proceed with a token payment of N50.00 to the account number below:"
    (cancel)="showBankDetails = false"
    [buttonText]="'I have made the transfer'"
    (submit)="confirmTransfer()"
    [hideSubmitButton]="false"
    >
    <div class="bank-details">
      <div class="bank-details--wrapper">
        <div class="bank-details__div">
          <p class="bank-details__text">Bank</p>
          <p class="bank-details__value">Fidelity Bank</p>
        </div>
        <div class="bank-details__div">
          <p class="bank-details__text">Account Number</p>
          <p class="bank-details__value">9020025928</p>
        </div>
        <div class="bank-details__div">
          <p class="bank-details__text">Account Name</p>
          <p class="bank-details__value">NIBSS Mandate Activation</p>
        </div>
      </div>
      <p class="mt-2">
        A notification for successful mandate setup will be sent once verified.
      </p>
    </div>
  </app-modal>
}
